/**
 * @name results.controller:FastResult
 * @description
 * # FastResult
 * Listen for appropriate event, on event callback perform get AJAX request
 * for fast race result, if full result for this race available, perform get
 * AJAX request for full race result, on success callback compile response,
 * insert it into view and destroy directive. In case full race result is
 * unavailable - broadcast event for setting fast results with response of
 * first get AJAX request
 */
export default function ($scope, $element, $http, $rootScope, $compile, config) {
    'ngInject';

    /**
     * Variables for event listening and broadcasting
     *
     * @type {string} Race id
     * @type {string} Name of event which directive should listen
     * @type {string} Name of event which directive should broadcast
     */
    $scope.raceId = $element.data('raceId');
    $scope.emptySelector = $element.data('emptySelector');
    $scope.crsId = $element.data('crsId');
    $scope.getEvent = `getFastResults[${$scope.raceId}]`;
    $scope.getFullEvent = `getFullResults[${$scope.raceId}]`;
    $scope.showMeeting = `showMeetingContainer[${$scope.crsId}]`;
    $scope.fastDiffusionResultEvent = `setFastResults[${$scope.raceId}]`;
    // To avoid displaying a wrong view due to bug with API. Should be deleted when
    // https://racingpost.atlassian.net/browse/PR-1643 would be fixed.
    const fastReg = new RegExp(/data-directive-fast-result/);

    /**
     * Make get AJAX request for full race result. On success render response into view
     *
     * @param {string} raceDate Date of the race
     * @param {number} raceId Race id
     * @param {string} tab Name of the tab from which will be performed AJAX request
     */
    $scope.getFullResult = (raceDate, raceId, tab) => {
        const additionalParam = tab ? 'time-order' : $scope.crsId;
        const link = `${config.get('resultsPath')}/${raceDate}/${raceId}/${additionalParam}`;
        $http.get(link).success((data) => {
            if (data && !fastReg.test(data)) {
                $rootScope.$broadcast('hideErrorMessage');
                $element.after($compile(data)($scope));
                $element.parent()
                    .parent()
                    .removeClass($scope.emptySelector);
                $element.remove();
                $scope.$destroy();
            }
        });
    };

    /**
     * Make get AJAX request for fast race result. On success check is full result
     * for this race available. If true call $scope.getFullResult function, else
     * broadcast event for applying fast results into view
     *
     * @param {number} fastRaceId Race id in fast result response
     * @param {string} raceDate Date of the race
     * @param {string} tab Name of the tab from which will be performed AJAX request
     */
    $scope.getFastResult = (fastRaceId, raceDate, tab) => {
        if (fastRaceId) {
            const url = `${config.get('resultsPath')}/data/race/fast/${fastRaceId}.json`;

            $http.get(url).success((data) => {
                if (data.fullRaceId) {
                    $scope.getFullResult(raceDate, data.fullRaceId, tab);
                }
                $scope.setFastResultReceived();
            });
        }
    };

    /**
     * Shows meeting if it was hidden and removes error message
     */
    $scope.setFastResultReceived = () => {
        $rootScope.$broadcast('hideErrorMessage');
        $rootScope.$broadcast($scope.showMeeting);
        $element.removeClass($scope.emptySelector);
        $element.parent()
            .parent()
            .removeClass($scope.emptySelector);
    };

    /**
     * Listen for appropriate event and call $scope.getFastResult
     */
    $scope.$on($scope.getEvent, (event, data) => {
        $scope.getFastResult(data.fastRaceId, data.date, data.tab);
    });

    /**
     * Listen for event when fast result receives from diffusion
     */
    $rootScope.$on($scope.fastDiffusionResultEvent, () => {
        $scope.setFastResultReceived();
    });

    /**
     * Listen for appropriate event and call $scope.getFullResult
     */
    $scope.$on($scope.getFullEvent, (event, data) => {
        $scope.getFullResult(data.date, data.raceId, data.tab);
    });
}



// WEBPACK FOOTER //
// ./src/js/controllers/directiveFastResult.js